import styled from 'styled-components';

export const HistoryViewContainer = styled.div`
    height: 100%;
    overflow: auto;
    display: flex;
    justify-content: center;
    gap: 3rem;
`;

export const HistoryStatusContainer = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1 1 100%;
    padding-top: 8px;
`;

export const HistoryFormContainer = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1 1 30%;
`;
